module.exports = __webpack_public_path__ + "img/title.2297e617.jpg";